<template>
    <v-dialog v-model="dialogVisible" max-width="400" persistent>
        <v-card>
            <v-card-title class="text-h6">{{ title || 'Confirm Deletion' }}</v-card-title>

            <v-card-text>
                <span v-if="!isLoading">{{ message || 'Are you sure you want to delete this item?' }}</span>
                <div v-else class="text-center">
                    <v-progress-circular indeterminate color="primary" class="mb-2"></v-progress-circular>
                    <div>Deleting...</div>
                </div>
            </v-card-text>

            <v-card-actions v-if="!isLoading">
                <v-spacer />
                <v-btn variant="text" @click="closeDialog">Cancel</v-btn>
                <v-btn color="red" @click="confirmDelete" :loading="isLoading">Delete</v-btn>
            </v-card-actions>
        </v-card>
    </v-dialog>
</template>
<script lang="ts" setup>
import { ref } from 'vue'

const props = defineProps<{
    title?: string
    message?: string
    isLoading?: boolean
}>()

const emit = defineEmits<(e: 'delete-confirmed') => void>()

// Internal ref to control dialog visibility
const dialogVisible = ref(false)

// Dialog control methods
function showDialog() {
    dialogVisible.value = true
}

function hideDialog() {
    dialogVisible.value = false
}

function closeDialog() {
    if (!props.isLoading) {
        hideDialog()
    }
}

function confirmDelete() {
    // perform delete action here
    // Emit delete event
    emit('delete-confirmed')
}

// Expose methods to show/hide dialog to parent components
defineExpose({
    show: showDialog,
    hide: hideDialog
})
</script>
